<af-main-container [title]="documentName"
                   [showBackButton]="true"
                   [tabPathToTab]="tabPathToTab"
                   [showBreadcrumbs]="true"
                   [enableScroll]="false"
                   [specialFilter]="specialFilter"
                   [breadcrumbCustomizer]="breadcrumbCustomizer">
    @if (src && isVisible) {
        <div class="w-100 radius-16 bc-mono-white pdf-wrapper outer mt-24" fxLayoutAlign="center center">
            <div class="w-100 radius-16 bc-primary-gray-100 pdf-wrapper" fxLayoutAlign="center center">
                <pdf-viewer class="pdf-container"
                            [src]="src"
                            [render-text]="false"
                            [original-size]="false"/>
            </div>
        </div>
    }
    @if (!isVisible) {
        <div class="focus-overlay" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px">
            <span class="t2 c-primary-gray-600">{{ 'i18n_af_pdfViewerFocusLost' | translate }}</span>
            @if (countdown > 0) {
                <span class="t3 c-primary-gray-600">{{ 'i18n_af_pdfViewerCountdown' | translate: {count: countdown} }}</span>
            }
        </div>
    }
</af-main-container>
